<template>
    <b-modal
        :body-class="bodyClass"
        :hide-footer="hideFooter"
        :hide-header-close="localLoading || persistent"
        :hide-header="hideHeader"
        :no-close-on-backdrop="noCloseOnBackdrop || localLoading || persistent"
        :no-close-on-esc="noCloseOnEsc || localLoading || persistent"
        :size="size"
        :title="title"
        :visible="visible"
        @cancel="$emit('close')"
        @close="$emit('close')"
        @hide="$emit('hide')"
        ref="Modal"
    >
        <rkm-overlay :show="localLoading">
            <slot />
        </rkm-overlay>

        <template
            v-slot:modal-footer="{ cancel }"
        >
            <div class="w-100">
                <div class="float-left">
                    <slot name="footer-content" />
                </div>

                <div class="float-right">
                    <rkm-button
                        v-if="buttons.find(button => button === 'cancel')"
                        :disabled="localLoading"
                        @click="cancel"
                    >
                        Fechar
                    </rkm-button>

                    <slot
                        name="footer"
                        v-bind="{ cancel }"
                    />

                    <rkm-button
                        v-if="buttons.find(button => button === 'save')"
                        :disabled="localLoading"
                        @click="$emit('save', $event)"
                        :color="buttonSaveColor"
                    >
                        {{ buttonSaveText }}
                    </rkm-button>
                </div>
            </div>
        </template>
    </b-modal>
</template>

<script>
import { BModal } from 'bootstrap-vue'

export default {
    components: { BModal },
    computed: {
        localLoading() {
            return !!this.loading
        },
        size() {
            let size = 'md'

            if (this.small) {
                size = 'sm'
            }
            else if (this.large) {
                size = 'lg'
            }
            else if (this.extraLarge) {
                size = 'xl'
            }

            return size
        },
    },
    methods: {
        show() {
            this.$refs.Modal.show()
        },
        hide() {
            this.$refs.Modal.hide()
        },
    },
    props: {
        bodyClass: { type: [Array, Object, String] },
        buttons: { type: Array, default: () => [] },
        extraLarge: { type: Boolean },
        hideFooter: { type: Boolean },
        hideHeader: { type: Boolean },
        large: { type: Boolean },
        loading: { type: [Boolean, Number] },
        noCloseOnBackdrop: { type: Boolean, default: false },
        noCloseOnEsc: { type: Boolean, default: false },
        persistent: { type: Boolean },
        small: { type: Boolean },
        title: { type: String },
        visible: { type: Boolean },
        buttonSaveText: { type: String, default: 'Salvar'},
        buttonSaveColor: { type: String, default: 'primary'}
    },
}
</script>